import { onMounted, watch } from 'vue';
import useEnvParams from '@composables/useEnvParams';
import useInGridSPItemsAnalytics from '@modules/discovery/composables/useInGridSPItemsAnalytics';
import { useProsCollection } from './useProsCollection';
import { IProduct, ComputedRef } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

/**
 *
 * @param {ComputedRef<{product: IProduct}[]>} itemsRef
 * @param {Object.<string,Ref<HTMLElement>>} sponsoredItemRefs
 */
export default function useSortableGridItems(itemsRef, sponsoredItemRefs) {
  const { isMcom } = useEnvParams();

  const { clearProsCollection, initMcomProsCollection } = useProsCollection();
  const { initInGridSPItemsAnalytics } = useInGridSPItemsAnalytics();

  watch(itemsRef, () => {
    clearProsCollection();
    /* istanbul ignore else */
    if (isMcom) {
      initMcomProsCollection();
    }
  });

  onMounted(() => {
    /* istanbul ignore else */
    if (isMcom) {
      initMcomProsCollection();
    }
    initInGridSPItemsAnalytics(itemsRef, sponsoredItemRefs);
  });
}
